import { isMaintenanceModeEnabled } from '@/config/app';

export const MAINTENANCE_CHECK_SECONDS = 15 * 60;

export const startAccordingToMaintenanceMode = (
  maintenanceEnabled: boolean,
  startApplication: () => void,
  startMaintenance: () => void
): void => {
  if (maintenanceEnabled) {
    startMaintenance();
    return;
  }

  startApplication();
};

export const reloadRuntimeConfig = (): Promise<boolean> => new Promise((resolve, reject) => {
  if (typeof document === 'undefined') {
    resolve(isMaintenanceModeEnabled());
    return;
  }

  const script = document.createElement('script');
  const baseUrl = process.env.BASE_URL || '/';
  script.src = `${baseUrl}runtime-config.js?maintenance_check=${Date.now()}`;
  script.async = true;
  script.onload = () => {
    script.remove();
    resolve(isMaintenanceModeEnabled());
  };
  script.onerror = () => {
    script.remove();
    reject(new Error('Impossible de vérifier le statut de la maintenance.'));
  };
  document.head.appendChild(script);
});
